// extracted by mini-css-extract-plugin
export var avatarContainer = "_4y-0";
export var avatarTypingWave = "_4y-i";
export var gray = "_4y-f";
export var green = "_4y-c";
export var icon = "_4y-9";
export var image = "_4y-1";
export var lg = "_4y-6";
export var md = "_4y-5";
export var presenceDot = "_4y-b";
export var red = "_4y-d";
export var sm = "_4y-4";
export var status = "_4y-a";
export var typingDot = "_4y-h";
export var typingPill = "_4y-g";
export var xl = "_4y-7";
export var xs = "_4y-3";
export var xxl = "_4y-8";
export var xxs = "_4y-2";
export var yellow = "_4y-e";